<template>
  <div class="wndModalTitle">
    {{title}}
    <a class="btnWnd btnWndClose" href="javascript:;" @click="fnBtnClick()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="10px"
        height="10px"
      >
        <path
          fill-rule="evenodd"
          fill="rgb(136, 136, 136)"
          d="M8.000,6.000 L8.000,7.000 L9.000,7.000 L9.000,8.000 L10.000,8.000 L10.000,10.000 L8.000,10.000 L8.000,9.000 L7.000,9.000 L7.000,8.000 L6.000,8.000 L6.000,7.000 L4.000,7.000 L4.000,8.000 L3.000,8.000 L3.000,9.000 L2.000,9.000 L2.000,10.000 L-0.000,10.000 L-0.000,8.000 L1.000,8.000 L1.000,7.000 L2.000,7.000 L2.000,6.000 L3.000,6.000 L3.000,4.000 L2.000,4.000 L2.000,3.000 L1.000,3.000 L1.000,2.000 L-0.000,2.000 L-0.000,0.000 L2.000,0.000 L2.000,1.000 L3.000,1.000 L3.000,2.000 L4.000,2.000 L4.000,3.000 L6.000,3.000 L6.000,2.000 L7.000,2.000 L7.000,1.000 L8.000,1.000 L8.000,0.000 L10.000,0.000 L10.000,2.000 L9.000,2.000 L9.000,3.000 L8.000,3.000 L8.000,4.000 L7.000,4.000 L7.000,6.000 L8.000,6.000 Z"
        />
      </svg>
    </a>
  </div>
</template>

<!--独立弹窗用头部-->
<script>
export default {
  name: 'HeaderStyleB',
  props: {
    wndTitle: String
  },
  data () {
    return {
      title: '易乐玩游戏盒子特权'
    }
  },
  watch: {
    wndTitle () {
      this.fnChangeTitle()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.fnChangeTitle()
    })
  },
  methods: {
    fnChangeTitle () {
      this.title = this.wndTitle
    },
    fnBtnClick () {
      this.$emit('fnBtnClick', 'privilege')
    }
  }
}
</script>

<style lang="less" scoped>
</style>
